import apiClient from './client';

export interface Hub {
  id: number;
  name: string;
  description?: string | null;
  isActive: boolean;
  centerLatitude?: number | null;
  centerLongitude?: number | null;
  regionGeoJson?: { type: 'Polygon' | 'MultiPolygon'; coordinates: any } | null;
}

export interface PaginatedResponse<T> {
  success: boolean;
  data: T;
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export const getHubs = async (params?: { page?: number; limit?: number; isActive?: boolean }): Promise<PaginatedResponse<Hub[]>> => {
  const response = await apiClient.get('/hubs', { params });
  return response.data;
};
